// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---components-alert-index-mdx": () => import("./../../../../components/alert/index.mdx" /* webpackChunkName: "component---components-alert-index-mdx" */),
  "component---components-button-index-mdx": () => import("./../../../../components/button/index.mdx" /* webpackChunkName: "component---components-button-index-mdx" */),
  "component---components-tooltip-index-mdx": () => import("./../../../../components/tooltip/index.mdx" /* webpackChunkName: "component---components-tooltip-index-mdx" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

